import React = require("react");
import { DateInput } from "../inputs/DateInput";
import { TimeInput } from "../inputs/TimeInput";
import { ButtonRow } from "../button/ButtonRow";
import { FormField } from "./FormField";

type DateTimeFieldProps = 
{
    value:Date,
    label:string,
    infoMessage?:string,
    onChanged:(value:Date)=>void,
    validator:(value:Date)=>{valid:true} | { valid:false, errorMessage:string }
}
export function DateTimeField(props: DateTimeFieldProps): JSX.Element 
{
    function handleCombinedChange(newValue:Date|null)
    {
        props.onChanged(newValue);
    }

    function handleDateChange(newValue: Date | null) {
        if (newValue) {
            const newDateTime = new Date(newValue);
            newDateTime.setHours(props.value.getHours(), props.value.getMinutes(), 0, 0);
            handleCombinedChange(newDateTime)
        }
        else
            handleCombinedChange(newValue);
    }

    function handleTimeChange(newValue: Date | null) {
        if (newValue) {
            const newDateTime = new Date(props.value);
            // Set seconds to 0
            newDateTime.setHours(newValue.getHours(), newValue.getMinutes(), 0, 0);
            handleCombinedChange(newDateTime);
        }
        else
            handleCombinedChange(newValue);
    }

    const validatorResult = props.validator(props.value);

    return (
        <FormField 
            label={props.label} 
            inputComponent={
                <ButtonRow variant="stretched">
                    <DateInput
                        value={props.value}
                        onValueChange={handleDateChange} />
                    <TimeInput
                        timeIntervals={15}
                        value={props.value}
                        onValueChange={handleTimeChange} />
                </ButtonRow>
            }
            inErrorState={!validatorResult.valid}
            message={validatorResult.valid===true ? props.infoMessage || '' : validatorResult.errorMessage}
        />
    )
}
